import { render, staticRenderFns } from "./PieItem.vue?vue&type=template&id=1e061f7e"
import script from "./PieItem.vue?vue&type=script&lang=js"
export * from "./PieItem.vue?vue&type=script&lang=js"
import style0 from "./PieItem.vue?vue&type=style&index=0&id=1e061f7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports